import { parseEntityItemId } from '@wix/a11y-rules';
import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import _ from 'lodash';
import { useCallback } from 'react';
import { updateGalleryItems } from '../../api/tpa-apis/pro-gallery/update-gallery-items';
export const useSetGalleryItems = () => {
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  const setGalleryItems = useCallback(async _ref => {
    let {
      galleriesDataMap,
      galleryItemsData
    } = _ref;
    const galleryDataById = _.groupBy(galleryItemsData, _ref2 => {
      let {
        tpaData
      } = _ref2;
      return (tpaData == null ? void 0 : tpaData.entityId) ?? '';
    });
    const galleryUpdatePromises = Object.entries(galleryDataById).map(async _ref3 => {
      let [galleryId, galleryItems] = _ref3;
      const updatedGalleryItems = (galleryItems == null ? void 0 : galleryItems.map(_ref4 => {
        var _galleriesDataMap$get;
        let {
          alt,
          id
        } = _ref4;
        const itemId = parseEntityItemId(id, 1).itemId;
        const originalGalleryItem = (galleriesDataMap == null || (_galleriesDataMap$get = galleriesDataMap.get(galleryId)) == null ? void 0 : _galleriesDataMap$get.find(item => item.id === itemId)) ?? {};
        const updatedGalleryItem = {
          ...originalGalleryItem,
          alt
        };
        return updatedGalleryItem;
      })) ?? [];
      return updateGalleryItems(httpClient, errorHandler, galleryId, updatedGalleryItems);
    });
    const updatedGalleries = await Promise.all(galleryUpdatePromises);
    return updatedGalleries;
  }, [errorHandler, httpClient]);
  return {
    updateGalleryItems: setGalleryItems
  };
};
//# sourceMappingURL=use-set-gallery-items.js.map